@import '../../../global/global.pcss';

:host {
  height: inherit;
  width: inherit;
  & > slot {
    height: inherit;
  }
}
